export default __webpack_public_path__ + "static/media/gym-website.04cec876.PNG";